module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_chugoku-e147564eb750312142df7ae9c9279fcc.png";